import { Fragment, useRef, useContext, useEffect, useState } from "react";
import stylesModal from "../../../../components/UnifiedTaxDeclaration/forms/formTypes/Modal.module.css";

import stylesRequestData from "../../UnifiedTaxDeclarationRequestData/index.module.css";
import SearchSelectElement from "../../../../shared/form/SearchSelectElement";
import InputElement from "../../../../shared/form/InputElement";
import UnifiedTaxDeclarationContext from "../../../../contexts/UnifiedTaxDeclarationProvider";
import { validateRequired } from "../../../../helpers/Validation";
import { get, post } from "../../../../adapters/xhr/api";
import Modal from "react-modal";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { profileVerificationEmail } from "../../../../adapters/apis/auth/auth";

const UserForm = ({
  generateOptions,
  handleChangeApplicantRole,
  applicantRoles,
  error_new_user,
  fileInputKeys,
  handleChangeFile,
  handleChange,
  user,
  setError,

  handlePreviewFile,
}) => {
  Modal.setAppElement("body");
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const unifiedTaxDeclarationContext = useContext(UnifiedTaxDeclarationContext);
  const {
    declarationRequest,
    setPropertyTypes,
    updateDeclarationUnit,
    setDeclarationRequest,
  } = unifiedTaxDeclarationContext;

  const agencyFileInputRef = useRef();
  const jointOwnershipDocumentFileInputRef = useRef();
  const [showModal, setShowModal] = useState(false);
  const [checkEmailMessage, setCheckEmailMessage] = useState(false);
  const [emailErrorMessage, setEmailErrorMessage] = useState("");
  const isFirstRender = useRef(true);

  useEffect(() => {
    if ([5, 6, 7].includes(parseInt(declarationRequest?.applicant_role_id))) {
      if (isFirstRender.current) {
        isFirstRender.current = false;
        return;
      }

      // if (!validateRequired(declarationRequest?.power_of_attorney?.full_url)) {
      //   setError("power_of_attorney", "يجب رفع الصورة");
      // } else {
      //   setError("power_of_attorney", "");
      // }
    }

    // if (parseInt(declarationRequest?.applicant_role_id) === 2) {
    //   if (
    //     !validateRequired(
    //       declarationRequest?.joint_ownership_document?.full_url,
    //     )
    //   ) {
    //     setError("joint_ownership_document", "يجب رفع الصورة");
    //   } else {
    //     setError("joint_ownership_document", "");
    //   }
    // }
  }, [declarationRequest?.applicant_role_id]);

  const handleGetPropertyTypeBasedOn = async () => {
    try {
      const response = await get(
        `api/declaration-system/declaration-lookups/property-types?applicant_role_id=${declarationRequest?.applicant_role_id}`,
        {},
        false,
      );
      if (
        [1, 2].includes(parseInt(declarationRequest?.applicant_role_id)) &&
        parseInt(declarationRequest?.unit?.property_type_id) === 10
      ) {
        updateDeclarationUnit("property_type_id", null);
      }
      setPropertyTypes(response?.data?.data);
    } catch (error) {
      console.log("failed to get property types");
    }
  };

  const checkIsEmailVerified = async () => {
    try {
      const response = await get(`api/check-email-verified`, {}, false);
      if (response?.data?.email === null) {
        setCheckEmailMessage(
          "لا يمكن تقديم إقرار بهذه الصفة حتى يتم إدخال  بريدك الإلكتروني",
        );
        setDeclarationRequest((prev) => ({
          ...prev,
          applicant_role_id: null,
        }));
      }
    } catch (error) {
      setCheckEmailMessage(error?.response?.data?.message);
      setShowModal(true);
      setDeclarationRequest((prev) => ({
        ...prev,
        applicant_role_id: null,
      }));
    }
  };

  const checkIfUserCanCreateDeclarationWithSameApplicantRole = async () => {
    try {
      const data = {
        declaration_id: id || declarationRequest?.id || null,
      };

      const response = await post(
        `api/declaration-system/declarations/check-applicant-role/${declarationRequest?.applicant_role_id}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
          },
        },
        data,
      );

      if (response?.data?.data?.exists) {
        setError(
          "applicant_role_id",
          "لا يمكن إختيار هذه الصفة لوجود إقرار عام آخر بنفس هذه الصفة على النظام في نفس الفترة",
        );
      } else {
        setError("applicant_role_id", "");
      }
    } catch (error) {
      console.log("failed to check applicant role");
    }
  };

  useEffect(() => {
    if (
      declarationRequest?.applicant_role_id !== null
      //  &&
      // !declarationRequest?.viewMode
    ) {
      handleGetPropertyTypeBasedOn();
    }
  }, [declarationRequest?.applicant_role_id]);

  useEffect(() => {
    if (
      declarationRequest?.applicant_role_id !== null &&
      [5, 6, 7].includes(parseInt(declarationRequest?.applicant_role_id)) &&
      !declarationRequest?.viewMode
      // (location?.pathname?.includes("add") ||
      //   (declarationRequest?.editMode && declarationRequest?.units_count === 0))
    ) {
      checkIsEmailVerified();
    }
  }, [declarationRequest?.applicant_role_id]);

  useEffect(() => {
    const isDisabled =
      parseInt(declarationRequest?.units_count?.total) >= 1 &&
      declarationRequest?.editMode;
    if (
      !declarationRequest?.viewMode &&
      declarationRequest?.applicant_role_id !== null &&
      [1, 3, 4].includes(parseInt(declarationRequest?.applicant_role_id)) &&
      !isDisabled
    ) {
      checkIfUserCanCreateDeclarationWithSameApplicantRole();
    } else {
      setError("applicant_role_id", "");
    }
  }, [declarationRequest?.applicant_role_id, declarationRequest?.editMode]);

  useEffect(() => {
    setEmailErrorMessage("");
    if (
      declarationRequest?.applicant_role_id === null ||
      declarationRequest?.applicant_role_id === ""
    ) {
      setError("applicant_role_id", "يجب اختيار صفة مقدم الإقرار");
    } else {
      setError("applicant_role_id", "");
    }
  }, [declarationRequest?.applicant_role_id]);

  const handleCheckEmail = () => {
    setEmailErrorMessage("");
    profileVerificationEmail({
      email: declarationRequest?.applicant?.email || user?.email,
    })
      .then((res) => {
        if (res.data.status == 422) {
          setEmailErrorMessage(res.data.message);
        } else {
          navigate(
            `/mail-verify-profile?email=${declarationRequest?.applicant?.email || user?.email}`,
            {
              state: { navigateToDecleration: true },
            },
          );
        }
      })
      .catch((error) => {
        setEmailErrorMessage(
          error?.response?.data?.message || "حدث خطأ أثناء إرسال البريد",
        );
      });
  };

  const applicantLastName = declarationRequest?.applicant
    ? declarationRequest?.applicant?.profile?.last_name ||
      declarationRequest?.applicant?.profile?.second_name +
        " " +
        declarationRequest?.applicant?.profile?.third_name +
        " " +
        declarationRequest?.applicant?.profile?.fourth_name
    : user?.father_name;

  return (
    <>
      <Modal
        isOpen={showModal}
        onRequestClose={() => setShowModal(false)}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        overlayClassName={stylesModal.overlay}
        className={stylesModal.content}
      >
        <div className="col-lg-8 text-center">
          <h5>{checkEmailMessage}</h5>
          <div className="d-flex gap-4 justify-content-center mt-3">
            <button
              className="btn btn-primary px-3 "
              onClick={handleCheckEmail}
            >
              التحقق من بريدك الإلكتروني
            </button>
            <button
              className="btn btn-primary px-3 "
              onClick={() => {
                navigate("/profile");
                setShowModal(false);
              }}
            >
              تعديل بيانات الحساب
            </button>
            <button
              className="btn btn-danger px-3 "
              onClick={() => setShowModal(false)}
            >
              إلغاء
            </button>
          </div>
          {emailErrorMessage !== "" && (
            <p className="text-danger mb-0 mt-2 me-2 fw-bolder">
              {emailErrorMessage}
            </p>
          )}
        </div>
      </Modal>
      <div className="row">
        <div className="col-md-4">
          <SearchSelectElement
            mb4="mb-4"
            labelHtmlFor="applicant_role_id"
            inputId="applicant_role_id_input"
            labelClassName={`required form-label ${stylesRequestData["form-label"]}`}
            labelText="صفة مقدم الإقرار"
            selectClassName={`${stylesRequestData["form-select"]} form-select`}
            selectID="applicant_role_id"
            name="applicant_role_id"
            options={generateOptions(applicantRoles)}
            default="أختار صفة مقدم الإقرار.."
            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
            value={parseInt(declarationRequest?.applicant_role_id)}
            onChange={handleChangeApplicantRole}
            pText={error_new_user.applicant_role_id}
            isClearable={true}
            disabled={
              declarationRequest?.viewMode ||
              (parseInt(declarationRequest?.units_count?.total) >= 1 &&
                declarationRequest?.editMode)
            }
          />
        </div>

        {!declarationRequest?.viewMode &&
          parseInt(declarationRequest?.applicant_role_id) === 2 && (
            <>
              <div className="col-md-4">
                <InputElement
                  fileInputRef={jointOwnershipDocumentFileInputRef}
                  mb4="mb-4"
                  key={`agency-${fileInputKeys.ownership}`}
                  inputIcon={`${stylesRequestData["input-icon"]} input-icon`}
                  labelHtmlFor="joint_ownership_document"
                  labelClassName={` required ${stylesRequestData["form-label"]} form-label  `}
                  labelText="صورة سند الملكية على الشيوع / إعلام الوراثة"
                  inputType="file"
                  inputClassName={`${stylesRequestData["form-control"]} form-control`}
                  inputID="joint_ownership_document_input"
                  name="joint_ownership_document"
                  fileName={
                    declarationRequest?.joint_ownership_document
                      ?.original_file_name || "إرفاق ملف"
                  }
                  pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                  icon="fa-solid fa-cloud-arrow-up"
                  accept="image/png, image/jpeg,image/jpg,application/pdf,image/JFIF"
                  pText={error_new_user.joint_ownership_document}
                  onChange={handleChangeFile}
                  customServerInput={
                    declarationRequest?.joint_ownership_document !== null
                      ? true
                      : false
                  }
                  disabled={declarationRequest?.viewMode}
                  deleteFunction={() => {
                    handleChange("", "", "joint_ownership_document", null);
                    if (jointOwnershipDocumentFileInputRef?.current) {
                      jointOwnershipDocumentFileInputRef.current.value = null;
                    }
                    setError("joint_ownership_document", "يجب رفع الصورة");
                  }}
                />
              </div>
            </>
          )}

        {parseInt(declarationRequest?.applicant_role_id) === 7 && (
          <div className="col-md-4">
            <InputElement
              mb4="mb-4"
              labelHtmlFor="applicant_role_other"
              labelClassName={` required ${stylesRequestData["form-label"]} form-label`}
              labelText="صفة مقدم الإقرار الأخرى"
              inputType="text"
              maxLength={100}
              inputClassName={`${stylesRequestData["form-control"]} form-control`}
              inputID="applicant_role_other_input"
              name="applicant_role_other"
              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
              value={declarationRequest?.applicant_role_other || ""}
              allowedPattern={
                /^[A-Za-z\u0621-\u063A\u0641-\u064A0-9\-_,.\/\\\s]+$/
              }
              onChange={handleChange}
              pText={error_new_user.applicant_role_other}
              disabled={
                declarationRequest?.viewMode ||
                (parseInt(declarationRequest?.units_count?.total) >= 1 &&
                  declarationRequest?.editMode)
              }
            />
          </div>
        )}
        {declarationRequest?.applicant_role_id && (
          <>
            <div className="col-md-4">
              <InputElement
                value={
                  declarationRequest?.applicant?.profile?.first_name ||
                  user?.first_name
                }
                disabled={true}
                name="tax_payer_first_name"
                mb4="mb-4"
                labelHtmlFor="tax_payer_first_name"
                labelClassName={` ${stylesRequestData["form-label"]} form-label`}
                labelText={" الإسم الأول لمقدم الإقرار"}
                inputType="text"
                inputClassName={`${stylesRequestData["form-control"]} form-control`}
                inputID="tax_payer_first_name_input"
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
              />
            </div>
            <div className="col-md-4">
              <InputElement
                value={`${applicantLastName} ` || ""}
                disabled={true}
                name="tax_payer_rest_name"
                mb4="mb-4"
                labelHtmlFor="tax_payer_rest_name"
                labelClassName={`${stylesRequestData["form-label"]} form-label`}
                labelText={"باقى الإسم لمقدم الإقرار"}
                inputType="text"
                inputClassName={`${stylesRequestData["form-control"]} form-control`}
                inputID="tax_payer_rest_name_input"
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
              />
            </div>
            <div className="col-md-4">
              <InputElement
                name="email"
                mb4="mb-4"
                labelHtmlFor="email"
                labelClassName={`${stylesRequestData["form-label"]} form-label`}
                labelText="البريد الإلكترونى"
                inputType="email"
                inputClassName={`${stylesRequestData["form-control"]} form-control`}
                inputID="email_input"
                value={declarationRequest?.applicant?.email || user?.email}
                disabled={true}
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
              />
            </div>
            <div className="col-md-4">
              <InputElement
                value={
                  declarationRequest?.applicant?.profile?.mobile ||
                  user?.phone_number
                }
                disabled={true}
                name="mobile"
                mb4="mb-4"
                labelHtmlFor="mobile"
                labelClassName={`${stylesRequestData["form-label"]} form-label`}
                labelText="رقم الهاتف"
                inputType="text"
                inputClassName={`${stylesRequestData["form-control"]} form-control`}
                inputID="mobile_input"
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                maxLength={11}
              />
            </div>
            <div className="col-md-4">
              <InputElement
                value={
                  declarationRequest?.applicant?.nationality?.value ||
                  user?.nationality?.value
                }
                disabled={true}
                name="natioanlity"
                mb4="mb-4"
                labelHtmlFor="natioanlity"
                labelClassName={`${stylesRequestData["form-label"]} form-label`}
                labelText="جنسية مقدم الإقرار"
                inputType="text"
                inputClassName={`${stylesRequestData["form-control"]} form-control`}
                inputID="natioanlity_input"
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
              />
            </div>
            {declarationRequest?.applicant?.nationality?.key === "EG" ||
            (user?.nationality?.key === "EG" &&
              !declarationRequest?.viewMode &&
              !declarationRequest?.editMode) ? (
              <Fragment>
                <div className="col-md-4">
                  <InputElement
                    value={
                      declarationRequest?.applicant?.profile?.national_id ||
                      user?.national_id
                    }
                    disabled={true}
                    name="national_id"
                    mb4="mb-4"
                    labelHtmlFor="national_id"
                    labelClassName={`${stylesRequestData["form-label"]} form-label`}
                    labelText="الرقم القومي لمقدم الإقرار"
                    inputType="text"
                    inputClassName={`${stylesRequestData["form-control"]} form-control`}
                    inputID="national_id_input"
                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                  />
                </div>
                {!declarationRequest?.viewMode &&
                  (declarationRequest?.applicant?.profile
                    ?.national_id_file[0] ||
                    user?.national_id_file) &&
                  (declarationRequest?.applicant?.profile?.national_id_file[0]
                    ?.url ||
                    user?.national_id_file?.url) && (
                    <div className="col-md-4">
                      <InputElement
                        value={
                          declarationRequest?.applicant?.profile
                            ?.national_id_file[0]?.original_file_name ?? "الملف"
                        }
                        disabled={true}
                        name="national_id_file"
                        mb4="mb-4"
                        labelHtmlFor="national_id_file"
                        labelClassName={` ${stylesRequestData["form-label"]} form-label`}
                        labelText="صورة الرقم القومي لمقدم الإقرار"
                        inputType="text"
                        inputClassName={`${stylesRequestData["form-control"]} form-control`}
                        inputID="national_id_file_input"
                        pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                        isIcon={
                          (declarationRequest?.applicant?.profile
                            ?.national_id_file[0]?.url ||
                            user?.national_id_file?.url) ??
                          ""
                        }
                        idDownload={
                          declarationRequest?.applicant?.profile?.id ||
                          user?.profile?.id
                        }
                        declarationId={declarationRequest?.id}
                        filedDownload="nationalIdFile"
                      />
                    </div>
                  )}
              </Fragment>
            ) : (
              <Fragment>
                <div className="col-md-4">
                  <InputElement
                    value={
                      declarationRequest?.applicant?.profile?.passport_num ||
                      user?.passport_number
                    }
                    disabled={true}
                    name="passport_num"
                    mb4="mb-4"
                    labelHtmlFor="passport_num"
                    labelClassName={` ${stylesRequestData["form-label"]} form-label`}
                    labelText="رقم جواز السفر لمقدم الإقرار"
                    inputType="text"
                    inputClassName={`${stylesRequestData["form-control"]} form-control`}
                    inputID="passport_num_input"
                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                  />
                </div>
                {!declarationRequest?.viewMode &&
                  (declarationRequest?.applicant?.profile
                    ?.passport_num_file[0] ||
                    user?.passport_num_file) &&
                  (declarationRequest?.applicant?.profile?.passport_num_file[0]
                    ?.url ||
                    user?.passport_num_file?.url) && (
                    <div className="col-md-4">
                      <InputElement
                        value={"الملف"}
                        disabled={true}
                        name="passport_num_file"
                        mb4="mb-4"
                        labelHtmlFor="passport_num_file"
                        labelClassName={`  ${stylesRequestData["form-label"]} form-label`}
                        labelText="صورة جواز السفر لمقدم الإقرار"
                        inputType="text"
                        inputClassName={`${stylesRequestData["form-control"]} form-control`}
                        inputID="passport_num_file_input"
                        pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                        isIcon={
                          (declarationRequest?.applicant?.profile
                            ?.passport_num_file[0]?.url ||
                            user?.passport_num_file?.url) ??
                          ""
                        }
                        idDownload={declarationRequest?.applicant?.profile?.id}
                        declarationId={declarationRequest?.id}
                        filedDownload="passportNumFile"
                      />
                    </div>
                  )}
              </Fragment>
            )}
            {!declarationRequest?.viewMode &&
              [5, 6, 7].includes(
                parseInt(declarationRequest?.applicant_role_id),
              ) && (
                <>
                  <div className="col-md-4">
                    <InputElement
                      fileInputRef={agencyFileInputRef}
                      mb4="mb-4"
                      key={`agency-${fileInputKeys.agency}`}
                      inputIcon={`${stylesRequestData["input-icon"]} input-icon`}
                      labelHtmlFor="power_of_attorney"
                      labelClassName={` required ${stylesRequestData["form-label"]} form-label  `}
                      labelText="صورة سند التوكيل/ سند التمثيل القانوني"
                      inputType="file"
                      inputClassName={`${stylesRequestData["form-control"]} form-control`}
                      inputID="power_of_attorney_input"
                      name="power_of_attorney"
                      fileName={
                        declarationRequest?.power_of_attorney
                          ?.original_file_name || "إرفاق ملف"
                      }
                      pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                      icon="fa-solid fa-cloud-arrow-up"
                      accept="image/png, image/jpeg,image/jpg,application/pdf,image/JFIF"
                      pText={error_new_user.power_of_attorney}
                      onChange={handleChangeFile}
                      // serverPreview={true}
                      customServerInput={
                        declarationRequest?.power_of_attorney !== null
                          ? true
                          : false
                      }
                      disabled={declarationRequest?.viewMode}
                      deleteFunction={() => {
                        handleChange("", "", "power_of_attorney", null);
                        if (agencyFileInputRef?.current) {
                          agencyFileInputRef.current.value = null;
                        }

                        setError("power_of_attorney", "يجب رفع الصورة");
                      }}
                    />
                  </div>
                  {/* <div>
                    {declarationRequest?.power_of_attorney !== null && (
                      <div className="col-md-4">
                        <div className=" col-2-4 d-flex border border-2  rounded-3 shadow-sm fs-6 justify-content-between bg-light py-1 px-2 align-items-center mb-3">
                          <p
                            className="mb-0 file-name fs-6"
                            title={
                              declarationRequest?.power_of_attorney
                                ?.original_file_name
                            }
                          >
                            {
                              declarationRequest?.power_of_attorney
                                ?.original_file_name
                            }
                          </p>
                          {!declarationRequest?.viewMode && (
                            <div className="d-flex align-items-center py-2">
                              <span
                                type="button"
                                onClick={() => {
                                  handleChange(
                                    "",
                                    "",
                                    "power_of_attorney",
                                    null,
                                  );
                                  if (agencyFileInputRef?.current) {
                                    agencyFileInputRef.current.value = null;
                                  }

                                  setError(
                                    "power_of_attorney",
                                    "يجب رفع الصورة",
                                  );
                                }}
                                className={`text-danger border-0`}
                              >
                                <i className="fa-solid fa-trash fa-lg px-2"></i>
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div> */}
                </>
              )}
          </>
        )}
      </div>
    </>
  );
};

export default UserForm;
